import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FormGroup } from "components/bootstrap";
import SegmentedControl from "components/bootstrap/SegmentedControl";
import useHealthModule from "health/useHealthModule";
import readableHealthAlertTarget from "./readableTarget";
import STATUS_OPTIONS from "./statusOptions";
import { STATUS_PRESETS } from "./types";
const StyledTitle = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacings.sm};
`;
const sameStatuses = (a, b) => a.length === b.length && a.every((status) => b.includes(status));
const presetFor = (statuses) => {
  var _a;
  return (_a = Object.keys(STATUS_PRESETS).find((preset) => sameStatuses(STATUS_PRESETS[preset], statuses))) != null ? _a : "warning_or_critical";
};
const HealthAlertEventDefinitionForm = ({ eventDefinition, onChange }) => {
  const { t } = useTranslation("enterprise_license");
  const { config } = eventDefinition;
  const { paths } = useHealthModule();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledTitle, null, t("health.alert.event_definition_title")), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement("label", { htmlFor: "health-alert-targets" }, t("health.alert.health_check")), /* @__PURE__ */ React.createElement("p", { id: "health-alert-targets" }, config.targets.map((target) => readableHealthAlertTarget(target, paths)).join(", "))), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement("label", { htmlFor: "health-alert-statuses" }, t("health.alert.alert_when")), /* @__PURE__ */ React.createElement("div", { id: "health-alert-statuses" }, /* @__PURE__ */ React.createElement(
    SegmentedControl,
    {
      data: STATUS_OPTIONS,
      value: presetFor(config.statuses),
      color: "neutral",
      onChange: (preset) => onChange("config", { ...config, statuses: STATUS_PRESETS[preset] })
    }
  ))));
};
export default HealthAlertEventDefinitionForm;
